<template>
  <main class="mdl-layout__content use-backdrop">
    <div class="page-content">
      <h1 class="section-header">AUTOTAKST</h1>
      <div class="mdl-grid">
        <div class="section-content mdl-cell--8-col-tablet">
          <p>Visuell Inspeksjon og Teknisk Inspeksjon - VI og TI</p>
        </div>
      </div>
    </div>

    <router-link v-if="$root.isSurveyorCapability() || $root.isRentalCapability() || $root.isRentalCheckCapability() || $root.isEuropcarCapability() || $root.isAldCapability()" id="new-assessment" class="mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored" :to="{ name: 'report-new'}">
      <i class="material-icons">add</i>
    </router-link>
  </main>
</template>

<script>
export default {
  data () {
    return {
      //msg: 'Welcome to Your Vue.js App'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if( vm.$root.isClient() )
          vm.$router.push({name: 'reports'})
    })
  }
}
</script>

<style lang="scss">
  .index-btn.mdl-button{
    position: absolute;
    right: 50px;
    bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?ce48f994